module.exports = __webpack_public_path__ + "img/thumb-russische-kipburgers.0b291177.jpg";